// extracted by mini-css-extract-plugin
module.exports = {"column":"FooterColumn_column__c3Epo","title":"FooterColumn_title__U3bdp","item":"FooterColumn_item__z67xg","storeLinkGroup":"FooterColumn_storeLinkGroup__PE5mc"};